export const KEY_CODES = {
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
}

export const RESOURCE_TYPES = [
    "activity",
    "audio",
    "document",
    "image",
    "miscellany",
    "podcast",
    "presentation",
    "url",
    "video",
    "videocast",
]

export const EXTENSION_GROUPS = {
    image: ["bmp", "ico", "gif", "jpeg", "jpg", "png", "svg", "tiff"],
    video: [
        "avi",
        "asf",
        "flv",
        "m4v",
        "mkv",
        "mov",
        "mp4",
        "mpeg",
        "mpg",
        "wmv",
        "ogv",
        "webm",
        "m2ts",
        "divx",
    ],
    audio: ["aac", "mp3", "ogg", "wav", "wma"],
    text: ["txt"],
    doc: [
        "doc",
        "docx",
        "ods",
        "odt",
        "pdf",
        "ppt",
        "pptx",
        "xls",
        "xlsm",
        "xlsx",
    ],
    compressed: ["zip", "rar", "arj", "tar.gz", "tgz", "gz", "pak"],
}

export const PREVIEWABLE_EXTENSIONS = [
    "bmp",
    "ico",
    "gif",
    "jpeg",
    "jpg",
    "png",
    "svg",
    "avi",
    "asf",
    "flv",
    "m4v",
    "mkv",
    "mov",
    "mp4",
    "mpeg",
    "mpg",
    "wmv",
    "ogv",
    "webm",
    "m2ts",
    "divx",
    "mp3",
    "ogg",
    "wav",
    "wma",
    "txt",
    "doc",
    "docx",
    "ods",
    "odt",
    "pdf",
    "ppt",
    "pptx",
    "xls",
    "xlsm",
    "xlsx",
]

export const NATIVELY_PREVIEWABLE_EXTENSIONS = [
    "ico",
    "gif",
    "jpeg",
    "jpg",
    "png",
    "mpg",
    "mp4",
    "mp3",
    "txt",
    "pdf",
]

export const ACTIVITY_TYPES = [
    "ANONYMOUS_POLL_V2",
    "CUSTOM_POLL_V2",
    "CUSTOM_POLL",
    "CUSTOM_POLLS",
    "EDUCATION_FIRST",
    "EDUCATION_FIRST_2",
    "EXAMS",
    "EXTERNAL_SIMULATOR_CIRCULATION",
    "GLOBAL_ENGLISH",
    "INTERVIEW",
    "JOB_TRAINING",
    "KNOWLEDGE_TEST",
    "LANGUAGE_TEST",
    "MEDICAL_TEST",
    "MIXED_POLLS",
    "OBJECTIVES",
    "OFFLINE_SESSIONS",
    "PEARSON_GLOBAL_ENGLISH",
    "PERFORMANCE_EVALUATION",
    "PERSONALITY_TEST",
    "POLLS_REPSOL",
    "POLLS_SATISFACTION",
    "POLLS",
    "RESPONSE_TEST",
    "SATISFACTION_POLL_V2",
    "SATISFACTION_POLL",
    "SCORM_VIDEO",
    "SCORM",
    "SIMULATOR",
    "SOCIAL_VIDEO",
    "TASKS_V2",
    "TASKS",
    "TNT",
    "UNIVERSAL_CONNECTOR",
    "VIRTUAL_CLASSROOMS", // It's not an actual activity but we'll treat it as such
    "VOLUNTARY_RELOCATION",
    "WEBROOM_SESSIONS",
    "WORKGROUPS",
    "WPF_REQUIREMENTS",
]

export const SUPPORTED_ACTIVITY_TYPES = [
    "CUSTOM_POLL_V2",
    "OFFLINE_SESSIONS",
    "POLLS",
    "SATISFACTION_POLL_V2",
    "SCORM_VIDEO",
    "SCORM",
    "SOCIAL_VIDEO",
    "TNT",
    "UNIVERSAL_CONNECTOR",
]

export const PLUGIN_BY_SSO = [
    "EXTERNAL_SIMULATOR_CIRCULATION",
    "SIMULATOR",
    "TASKS",
    "JOB_TRAINING",
]

export const ACTIVITY_STATUSES = [
    "Pending",
    "Coursing",
    "Succeeded",
    "Failed",
    "Expired",
    "Unevaluated",
    "Unrealized",
]

export const CALL_STATUSES = [
    "Pending",
    "Coursing",
    "Succeeded",
    "Failed",
    "Expired",
    "Cancelled",
    "Unevaluated",
    "Unrealized",
]

export const SCORM_CHAPTER_STATUSES = [
    "pending",
    "succeeded",
    "failed",
    "coursing",
]

export const ACTIVITY_PASS_MODES = [
    "access",
    "complete",
    "pass",
    "pass_and_complete",
]

export const PROGRAM_MODALITIES = ["online", "offline", "blended", "mixed"]

export const POLL_QUESTION_TYPES = [
    "FreeTextEvaluable",
    "FreeTextManual",
    "FreeTextOpinion",
    "FreeTextOptional",
    "JoinArrows",
    "MultipleChoice",
    "MultipleChoiceManual",
    "OneChoice",
    "Order",
    "Range",
    "RangeManual",
    "TrueOrFalse",
    "YesOrNo",
]

export const MAX_ITEMS_PER_BLOCK = 18

export const MESSAGES_POLLING_INTERVAL = 1000 * 30 // 30s
export const MESSAGES_MAX_USERS_COUNT = 500 // Max number of users that can be selected as recipients of a message

export const PLUGIN_DISABLING_TIME = 1000 * 3 // 3s

export const HEADER_HEIGHT = 50 // px

export const OFFICIAL_LIBRARIES = [
    "lms",
    "language",
    "communication",
    "community",
    "general_library",
    "my_documents",
]

export const BREAKPOINTS = {
    xxs: 0,
    xs: 320,
    s: 768,
    sm: 1024,
    md: 1280,
    l: 1440,
    xl: 1600,
    xxl: 1920,
    xxxl: Infinity,
}

export const TRAINING_REQUEST_STATUS_CODES = [
    "APPROVED",
    "DENIED",
    "PENDING_INFO",
    "PENDING_FINAL",
    "PENDING_RESPONSIBLE",
    "DELETED",
]

export const MIN_NOTIFICATION_LENGTH_TO_SHOW_CLOSE_BUTTON = 150

export const NOTICATION_CLOSING_TIME = 5000 // ms
